import React from "react"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import PortalCustomerPresenterTabs from "./PortalCustomerPresenterTabs"
import PortalCustomerPresenterTabContent from "./PortalCustomerPresenterTabContent"

class PortalCustomerPresenter extends React.Component {

  constructor(props) {
    // console.log('RTB', this.props);
    super(props);
    this.state = {
      loading: false,
      first_name: this.props.customer.first_name || null,
      middle_name: this.props.customer.middle_name || null,
      last_name: this.props.customer.last_name || null,
      email: this.props.customer.email || null,
      phone_number: this.props.customer.phone_number || null,
      formatted_phone: this.props.customer.formatted_phone || null,
      city: this.props.customer.city || null,
      state: this.props.customer.state || null,
      country: this.props.customer.country || null,
      salutation: this.props.customer.salutation || null,
      address_1: this.props.customer.address_1 || null,
      address_2: this.props.customer.address_2 || null,
      postal_code: this.props.customer.postal_code || null,
      google_token: this.props.customer.google_token || null,
      active_tab: 'general',

    }
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
  }

  componentDidMount() {
    var self = this
    $(window).on("customerSavedSuccessfully", function () {
      $.ajax({
        type: 'POST',
        url: `/portal/customers/${self.props.customer.id}/data`,
      }).done((data) => {
        self.setState({...data})
      })
    });
  }
  
  render() {
    var self = this;
    return (
      <div className="dates-and-times-builder">
        <div className="panel panel-form">
          <PortalCustomerPresenterTabs onChangeActiveTab={this.onChangeActiveTab} active_tab={this.state.active_tab}/>
          <PortalCustomerPresenterTabContent {...this.state} {...this.props} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  onChangeActiveTab(active_tab, event) {
    event.stopPropagation();
    event.preventDefault();
    this.setState({
      active_tab: active_tab
    })
  }
};

export default PortalCustomerPresenter